<script>
    import { selectCategory　} from "./sarch"
    import { slide } from 'svelte/transition'
    import { nightmode } from "../stores5.js"

</script>

<div class="select-category" class:select-category-night={$nightmode} transition:slide>
    <label><input type="radio" bind:group={$selectCategory} value="all"><span>すべて</span></label>
    <p>部門</p>
    <label><input type="radio" bind:group={$selectCategory} value="movie"><span>映像</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="exhibition"><span>展示</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="performance"><span>パフォーマンス</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="attraction"><span>アトラクション</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="drama"><span>劇</span></label>
    <div class="span"></div>
    <div class="span"></div>
    <div class="span"></div>
    <div class="span"></div>
    <div class="span"></div>
    <p>団体</p>
    <label><input type="radio" bind:group={$selectCategory} value="class"><span>クラス団体</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="club"><span>部活動/同好会/サークル</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="volunteer"><span>有志団体</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="committee"><span>委員会</span></label>
    <p>予約</p>
    <label><input type="radio" bind:group={$selectCategory} value="booking"><span>予約あり</span></label>
    <label><input type="radio" bind:group={$selectCategory} value="noBooking"><span>予約なし</span></label>
</div>


<style>
.select-category label span{
    font-size:18px;
    font-weight:700;
    margin-right:0;
    margin-left:30px;
    padding-top:20px;
    display:flex;
    align-items: center;
    justify-content:flex-start;
    border-bottom:3px solid #ffffff;
    transition: .3s;
    cursor: pointer
}
.select-category-night label span{
    border-bottom:3px solid #222831;
}
.select-category label{
    position:relative;
    margin:10px 10% 10px 0;
    width:40%;
}
.select-category span::before{
    position:absolute;
    content: '';
    display: block;
    top:-5px;
    left:10px;
    width:30px;
    height:30px;
    border:1px solid black;
}
.select-category-night span::before{
    border:1px solid #dddddd;
}
.select-category span::after{
    position:absolute;
    content: '';
    display: block;
    top:6px;
    left:21px;
    width:10px;
    height:10px;
    background-color:greenyellow;
    opacity: 0;
    transition: .3s;
}
.select-category label input:checked + span::after{
    opacity:1;
}
.select-category label input:checked + span{
    border-bottom:3px solid greenyellow;
    transform:.3s
}
.select-category input{
    display:none;
}
.select-category p{
    width:50%;
    font-size:24px;
    font-weight:700;
    margin-top:20px;
    margin-bottom:20px;
}
.select-category{
    height:660px;
    width:85%;
    margin-left:2%;
    margin-top:30px;
    margin-bottom:20px;
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.select-category-night{
    background-color:#222831;
    color:#dddddd;
}
.span{
    width:50%;
    height:59px;
}
@media screen and (max-width:600px){
    .span{
        height:0;
    }
    .select-category{
        height:900px;
    }
    .select-category label{
        width:100%;
    }
}
</style>